<div role="group" class="mat-input-tel-container"
     [formGroup]="parts"
	 [attr.aria-labelledby]="_formField?.getLabelId()">
	<span class="mat-input-tel-paren">&#40;</span>
  <input 
         type="tel"
         pattern="[0-9]*" 
         class="mat-input-tel-element"
         formControlName="area" size="3"
         maxLength="3"
         aria-label="Area code"
		 (input)="_handleInput(parts.controls.area, exchange)"
		 (blur)="onBlur()"
         #area
         (keydown)="preventNonNumber($event)">
  <span class="mat-input-tel-paren">&#41;</span>
  <input 
         type="tel"
         pattern="[0-9]*"
         class="mat-input-tel-element"
         formControlName="exchange"
         maxLength="3"
         size="3"
         aria-label="Exchange code"
         (input)="_handleInput(parts.controls.exchange, subscriber)"
		 (keyup.backspace)="autoFocusPrev(parts.controls.exchange, area)"
		 (blur)="onBlur()"
         #exchange
         (keydown)="preventNonNumber($event)">
  <span class="mat-input-tel-spacer">&ndash;</span>
  <input 
         type="tel"
         pattern="[0-9]*"
         class="mat-input-tel-element"
         formControlName="subscriber"
         maxLength="4"
         size="4"
         aria-label="Subscriber number"
         (input)="_handleInput(parts.controls.subscriber)"
		 (keyup.backspace)="autoFocusPrev(parts.controls.subscriber, exchange)"
		 (blur)="onBlur()"
         #subscriber
         (keydown)="preventNonNumber($event)">
</div>
